module.exports = __webpack_public_path__ + "static/media/bark.382176cd.png";